
namespace RioERP.Orders {
    import fld = OrdersRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class OrdersGrid1 extends Serenity.EntityGrid<OrdersRow, any> {
        protected getColumnsKey() { return 'Orders.Orders' }
        protected getDialogType() { return OrdersDialog; }
        protected getIdProperty() { return OrdersRow.idProperty; }
        protected getInsertPermission() { return OrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return OrdersRow.localTextPrefix; }
        protected getService() { return OrdersService.baseUrl; }
      

        constructor(container: JQuery) {
            super(container);
            
        }
      
       
        protected getQuickFilters() {

            var filters = super.getQuickFilters();


            
            return [];

        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 4);

            return buttons;
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.CustomerId != null;
        }


        private _CustomerId: number;

        get CustomerId() {
            return this._CustomerId;
        }
        set CustomerId(value: number) {
            if (this._CustomerId != value) {
                this._CustomerId = value;
                this.setEquality(OrdersRow.Fields.CustomerId, value);
                this.refresh();
            }
        }
    }
}